import classnames from 'classnames';
import { useState } from 'react';
import * as React from 'react';
import { Icon } from 'palette/Icon';
import './SearchInput.scss';

interface SearchInputProps {
    className?: string;
    value?: string;
    placeholder?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    inputClassName?: string;
}

export default function SearchInput({
    className,
    placeholder,
    onChange,
    value = '',
    inputClassName,
} : SearchInputProps) {
    const [inputValue, setInputValue] = useState(value);

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
        onChange?.(event);
    };

    return (
        <div className={classnames('palette-search-input', className)}>
            <div className="palette-search-input__icon">
                <Icon
                    name="palette_search"
                    size="x-small"
                />
            </div>
            <input
                className={classnames('palette-search-input__input skip-generic-styling', inputClassName)}
                placeholder={placeholder}
                type="text"
                value={inputValue}
                onChange={changeHandler}
            />
        </div>
    );
}
